import { createActions, createReducer, Types as ReduxSauceTypes } from 'reduxsauce';
import INITIAL_STATE from './specialists-model.js';
import { normalizeSpecialists } from 'utils/specialists.js';

const defaultHandler = (state = INITIAL_STATE) => state;

const fetched = (state, { data }) => ({
  ...state,
  items: normalizeSpecialists(data),
  specialistsToUpdateOrder: [],
});

const openModal = (state, { specialist }) => ({
  ...state,
  isModalOpen: true,
  specialistToUpdate: {
    ...INITIAL_STATE.specialistToUpdate,
    ...specialist,
  },
});

const closeModal = (state) => ({
  ...state,
  isModalOpen: false,
  specialistToUpdate: INITIAL_STATE.specialistToUpdate,
});

const updateOrder = (state, { oldIndex, newIndex }) => {
  const activeItems = state.items.filter((item) => item.active);
  const movedItem = activeItems.splice(oldIndex, 1)[0];

  if (!movedItem) return state;

  activeItems.splice(newIndex, 0, movedItem);

  const updatedActiveItems = activeItems.map((item, index) => ({
    ...item,
    order: index + 1,
  }));
  const inactiveItems = state.items.filter((item) => !item.active);

  return {
    ...state,
    items: [...updatedActiveItems, ...inactiveItems],
    specialistsToUpdateOrder: updatedActiveItems.map((item) => ({
      id: item.id,
      order: item.order,
    })),
  };
};

export const { Types, Creators } = createActions({
  specialistsFetched: ['data'],
  specialistsUpdateOrder: ['oldIndex', 'newIndex'],
  specialistsOpenModal: ['specialist'],
  specialistsCloseModal: [],

  specialistsCreateAsync: ['data'],
  specialistsUpdateAsync: ['data'],
  specialistsFetchAsync: [],
  specialistsUpdateOrdersAsync: [],
});

export default createReducer(INITIAL_STATE, {
  [ReduxSauceTypes.DEFAULT]: defaultHandler,
  [Types.SPECIALISTS_FETCHED]: fetched,
  [Types.SPECIALISTS_OPEN_MODAL]: openModal,
  [Types.SPECIALISTS_CLOSE_MODAL]: closeModal,
  [Types.SPECIALISTS_UPDATE_ORDER]: updateOrder,
});
